<template>
    <div id="app" class="app fond">
        <div class="DivImageHautPage">
            <img :src="Page.image" class="imageHautPage" :alt="'Image'+Page.page">
        </div>

        <div class="fond-page">
            <section class="corps-texte">
                <section class="en-tete-page">
                    <h1>{{Page.page}}</h1>
                    <p class="paragraphe-en-tete" v-if="Page.description != ''" v-html="Page.description"></p>
                </section>
                <h2 class="inter-titre">Comptes-rendus des conseils municipaux <i> entre le {{ dateJourNum }} - {{ dateAncienneAffMUn }}</i></h2>
                <section class="Section-pages section-pages-cartes" v-if="CRMRecents.length >= 1">
                    <div v-for="compterendu in CRMRecents" :key="compterendu.id">
                        <h6 style="text-align: center;">{{compterendu.date}}</h6>
                        <div class="carte-conseiller">
                            <div>
                                <iframe :src="compterendu.fichier_pdf" height="100%" width="100%"></iframe>
                            </div>
                        </div>
                        <br>
                        <br>
                        <div class="button">
                            <a  :href="compterendu.fichier_pdf" target="_blank">Ouvrir le document</a>
                        </div>
                    </div> 
                </section>
                <section v-if="CRMRecents.length == 0" >
                    <h6 style="text-align: center">Aucun compte-rendu des conseils municipaux datant d'après le {{dateAncienneAffMUn}} n'est disponible actuellement.</h6>
                    <br>
                    <br>
                    <div class="button">
                        <router-link  to="/publications">Voir les anciens comptes-rendus des conseils municipaux</router-link>
                    </div>
                </section>

                <h3 class="inter-titre" style="text-align: left">Échos de Quenne Nangis <i> entre le {{ dateJourNum }} - {{ dateAncienneAffMUn }}</i></h3>
                <section class="Section-pages section-pages-cartes" v-if="EQNOrderByDate.length >= 1">
                
                    <div v-for="Echo in EQNOrderByDate" :key="Echo.id">
                        <div> 
                            <h6 style="text-align: center;">{{Echo.date_fr}}</h6>
                            <div class="carte-conseiller">
                                <div>
                                    <iframe :src="Echo.fichier_pdf" height="100%" width="100%"></iframe>
                                </div>
                            </div>
                            <br>
                            <br>
                            <div class="button">
                                <a  href="" target="_blank">Ouvrir le document</a>
                            </div>
                        </div>
                    </div> 
                </section>
                <section v-if="EQNOrderByDate.length == 0" >
                    <h6 style="text-align: center">Aucun Échos de Quenne datant d'après le {{dateAncienneAffMUn}} n'est disponible actuellement.</h6>
                    <br>
                    <br>
                    <div class="button">
                        <router-link  to="/publications">Voir les anciens Échos</router-link>
                    </div>
                </section>

                <h3 class="inter-titre" style="text-align: left">Quenne informations <i> entre le {{ dateJourNum }} - {{ dateAncienneAffMUn }}</i></h3>
                <section class="Section-pages section-pages-cartes" v-if="QIOrderByDate.length >= 1">
                    <div v-for="quenneInfo in QIOrderByDate" :key="quenneInfo.id">
                        <h6 style="text-align: center;">{{quenneInfo.date_fr}}</h6>
                        <div class="carte-conseiller">
                            <div>
                                <iframe :src="quenneInfo.fichier_pdf" height="100%" width="100%"></iframe>
                            </div>
                        </div>
                        <br>
                        <br>
                        <div class="button">
                            <a  :href="quenneInfo.fichier_pdf" target="_blank">Ouvrir le document</a>
                        </div>
                    </div> 
                </section>  
                <section v-if="QIOrderByDate.length == 0" >
                    <h6 style="text-align: center">Aucune liste de délibérations datant d'après le {{dateAncienneAffMUn}} n'est disponible actuellement.</h6>
                    <br>
                    <br>
                    <div class="button">
                        <router-link  to="/publications">Voir les anciennes Quenne Info</router-link>
                    </div>
                </section> 
            </section>
        </div>
    </div>
</template>

<script>
import param from '@/param/param'

export default {
    name: 'InfosMunicipales',
    data () {
        return{
            listeComptesRendus:[],
            Page: {
                page: 'Erreur chargement',
                image: 'https://mairie-quenne.fr/wp-content/uploads/2022/05/Accueil.jpg',
                description: ''
            },
            listeDeliberations: [],
            CRMRecents: [],
            listeEQN: [],
            listeQI: []
        }
    }, 

    created(){
        var currentdate = new Date();
        var date = new Date;
        var annee = date.getFullYear();
        var moi = date.getMonth();
        var mois = new Array('Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin', 'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre');
        var moisnumerique = new Array('01', '02', '03', '04', '05', '06', '07', '08', '09', '10', '11', '12');

        var j = date.getDate();
        if(j < 10){
            j = '0'+j
        }
        var jour = date.getDay();
        var jours = new Array('Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi');
        this.date = jours[jour]+' '+j+' '+mois[moi]+' '+annee+'';
        this.time = currentdate.getHours()+" h "+currentdate.getMinutes()+" min "+currentdate.getSeconds()+" sec";
        this.joursemaine = jours[jour];
        this.datejour = +j+'/'+moi;
        this.dateJourNum = j+'/'+moisnumerique[moi]+'/'+annee;
        this.DateMaxEN = annee+'-'+moisnumerique[moi]+'-'+j;
        this.jourInfini = mois[moi];
        this.anneeMUn = annee - 1
        this.anneePUn = annee + 1
        this.anneeMTrois = annee - 3
        this.dateAncienneNumUn = this.anneeMUn+'-'+moisnumerique[moi]+'-'+j;
        this.dateAncienneNumUnCompa = this.anneeMUn+moisnumerique[moi]+j;
        this.dateAncienneAffMUn = j+1+'/'+moisnumerique[moi]+'/'+this.anneeMUn;
        this.dateAncienneAffMUnCompa = this.anneeMUn+moisnumerique[moi]+j;
        this.dateAncienneNum = this.anneeMTrois+'-'+moisnumerique[moi]+'-'+j;
        this.dateFutureNum = annee+'-'+moisnumerique[moi]+'-'+j;


        this.dateMin = this.dateAncienneNum;
        this.dateMax = this.dateFutureNum


        axios.get(param.host+'quenneInfo/v1/listeQuenneInfos')
        .then(response =>{
            this.listeQuenneInfos = response.data;
            let Echos = new Array;
            let QI = new Array;
            let r = 0;
            let s = 0;
            for(var k = 0; this.listeQuenneInfos.length > k; k++){
                this.dateSplit = this.listeQuenneInfos[k].date.split('/');
                this.listeQuenneInfos[k].date_fr = this.dateSplit[1]+'/'+this.dateSplit[0]+'/'+this.dateSplit[2];
                this.listeQuenneInfos[k].date_comparaison = this.dateSplit[2]+this.dateSplit[0]+this.dateSplit[1];
                console.log(this.listeQuenneInfos[k].date_comparaison, this.dateAncienneAffMUnCompa)

                if(this.listeQuenneInfos[k].type == 'Échos de Quenne' && this.listeQuenneInfos[k].date_comparaison > this.dateAncienneAffMUnCompa){
                    Echos[r] = this.listeQuenneInfos[k];
                    r++;
                }if(this.listeQuenneInfos[k].type == 'Quenne informations' && this.listeQuenneInfos[k].date_comparaison > this.dateAncienneAffMUnCompa){
                    QI[s] = this.listeQuenneInfos[k];
                    s++;
                }

                

            }

            function compare(a, b){
                if(a.date_comparaison > b.date_comparaison) return -1
                if(a.date_comparaison < b.date_comparaison) return 1
                return 0
            }

            this.listeEchos = Echos.sort(compare)
            this.listeQI = QI.sort(compare)
        })
        .catch(error => console.log(error))

        axios.get(param.host+'listeDeliberations/v1/listeListeDeliberations')
        .then(response =>{
            this.listeComptesRendus = response.data;
            let CRM = new Array;
            let CRMRecent = new Array;
            var i = 0;
            var k = 0;

            for(var j = 0; this.listeComptesRendus.length > j; j++){
                this.dateSplitCRM = this.listeComptesRendus[j].date.split('/');
                this.listeComptesRendus[j].date_comparaison_crm = this.dateSplitCRM[2]+this.dateSplitCRM[1]+this.dateSplitCRM[0];
                this.listeComptesRendus[j].date = this.dateSplitCRM[1] +'/'+ this.dateSplitCRM[0]+'/'+ this.dateSplitCRM[2]

                if(this.listeComptesRendus[j].date_comparaison_crm < this.dateAncienneNumUnCompa){
                    CRM[i] = this.listeComptesRendus[j];
                    i++;
                }else{
                    CRMRecent[k] = this.listeComptesRendus[j];
                    k++;
                }

                this.listeComptesRendusAnciens = CRM;
                this.CRMRecents = CRMRecent;
            }
        })
        .catch(error => console.log(error))

        axios.get(param.host+'page/v1/listePages')
        .then(response =>{
            this.listePages = response.data;
            this.Page = {
                page: 'Erreur chargement',
                image: param.hostContent+'uploads/2022/05/Accueil.jpg',
                description: ''
            }
            for(var i = 0; this.listePages.length > i; i++){
                if(this.listePages[i].page == 'Informations municipales'){
                    return this.Page = this.listePages[i]
                }
            }
        })
        .catch(error => console.log(error))

        axios.get(param.host+'deliberation/v1/listeDeliberations')
        .then(response => {
            this.listeDeliberations = response.data;
        })
        .catch(error => console.log(error))
    },

    computed:{
        CRCMOrderByDate: function(){
            
            function compare(a, b){
                if(a.date_comparaison_crm > b.date_comparaison_crm) return -1
                if(a.date_comparaison_crm < b.date_comparaison_crm) return 1
                return 0
            }
            if(this.listeComptesRendusAnciens != 'undefined'){
                return this.listeComptesRendusAnciens.sort(compare)
            }else{
                return this.listeComptesRendusAnciens = ''
            }
        },

        QIOrderByDate: function(){
            function compare(a, b){
                if(a.date_comparaison > b.date_comparaison) return -1
                if(a.date_comparaison < b.date_comparaison) return 1
                return 0
            }
            if(this.listeQI.length > 0){
                return this.listeQI.sort(compare)
            }else{
                return this.listeQI = ''
            }
        },

        EQNOrderByDate: function(){
            function compare(a, b){
                if(a.date_comparaison > b.date_comparaison) return -1
                if(a.date_comparaison < b.date_comparaison) return 1
                return 0
            }
            if(this.listeEchos.length > 0){
                return this.listeEchos.sort(compare)
            }else{
                return this.listeEchos = ''
            }
        },
    }
}
</script>

<style scoped>

</style>




// WEBPACK FOOTER //
// src/components/Infos-municipales.vue